import '../styles/conclusion.scss'

const Conclusion = () => {
  return (
    <div className="cta-screen">
      <div className="main-section">
        <div className="heading">
          This data equips practitioners to <strong>act now…</strong> from
          integrating small tweaks to driving radical transformation across
          career services
        </div>
        <div className="circles">
          <div className="circle circle-1">
            <div className="title">Equip</div>
            <p className="hover">
              <strong>Equip</strong> career services centers with student-level
              data (like those found with the diagnostic) to inform their career
              counseling
            </p>
          </div>
          <div className="circle circle-2">
            <div className="title">Develop</div>
            <p className="hover">
              <strong> Develop</strong> a gen-education course for all incoming
              first-years, differentiated by department and incoming levels of
              exposure
            </p>
          </div>
          <div className="circle circle-3">
            <div className="title">Deploy</div>
            <p className="hover">
              <strong>Deploy </strong>and credential an “exposure” score
              alongside or in lieu of GPA that students can share with
              prospective employers
            </p>
          </div>
        </div>
      </div>

      <div className="conclusion">
        <p className="concluding-text">
          Together, we can take a leap to fulfill the promise of a college
          degree for <strong>ALL</strong> students
        </p>
      </div>
    </div>
  )
}

export default Conclusion
